var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCheckboxFalse = function SvgCheckboxFalse(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeMiterlimit: 10,
    d: "M10.05 6.352c-1.36-.786-2.891-.212-3.395 1.28 0 0-.655 1.904-.655 4.474 0 2.57.584 4.262.584 4.262.494 1.492 2.016 2.066 3.376 1.28l7.346-4.242c1.36-.786 1.36-2.076 0-2.862L10.05 6.352Z"
  })));
};
export default SvgCheckboxFalse;